import { apiSlice } from "../../api/apiSlice";

export const translationsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSurveys: builder.query({
      query: () => {
        return `/surveys/`;
      },
      keepUnusedDataFor: 600,
      providesTags: ['Surveys'],
    }),
    getTranslations: builder.query({
      query: ({ surveyID, localeID }) => {
        return `/translations/?survey_id=${surveyID}&locale=${localeID}`;
      },
      keepUnusedDataFor: 600,
      providesTags: ["Translations"],
    }),
    saveUpdated: builder.mutation({
      query: ({ data, surveyID, localeID }) => ({
        url: `/translations/?survey_id=${surveyID}&locale=${localeID}`,
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data }),
      }),
      invalidatesTags: ["Translations", "Surveys"],
    }),
    saveNew: builder.mutation({
      query: ({ data, surveyID, localeID }) => ({
        url: `/translations/?survey_id=${surveyID}&locale=${localeID}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ data }),
      }),
      invalidatesTags: ["Translations", "Surveys"],
    }),
    deleteTranslation: builder.mutation({
      query: ({ editedData, surveyID, localeID }) => ({
        url: `/translations/?survey_id=${surveyID}&locale=${localeID}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ editedData }),
      }),

      invalidatesTags: ["Translations", "Surveys"],
    }),
  }),
});

export const {
  useGetSurveysQuery,
  useGetTranslationsQuery,
  useSaveUpdatedMutation,
  useSaveNewMutation,
  useDeleteTranslationMutation
} = translationsApiSlice;
